<template>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('kbReview.kbR', { msg: 'kbReview.kbR' })" name="first">
       
        <div>
            <el-steps :active="1" finish-status="success" simple style="margin-top: 20px">
            <el-step :title="$t('kbReview.review', { msg: 'kbReview.review' })" ></el-step>
            <!-- <el-step :title="$t('kbReview.pass', { msg: 'kbReview.pass' })" icon="el-icon-document-checked"></el-step> -->
            <el-step :title="$t('kbReview.recycle', { msg: 'kbReview.recycle' })" icon="el-icon-delete"></el-step>
            </el-steps>
        </div>

        <el-table
            border
            highlight-current-row
            stripe
            :data="tableData"
            @row-dblclick="handleOpenEdit"
            style="width: 100%"
            :row-class-name="tableRowClassName">
            <el-table-column
                prop="id"
                :label="$t('kbReview.table.id', { msg: 'kbReview.table.id' })"
                width="80">
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('kbReview.table.title', { msg: 'kbReview.table.title' })"
                width="750">
            </el-table-column>
            <el-table-column
                prop="type"
                :label="$t('kbReview.table.kbType', { msg: 'kbReview.table.kbType' })"
                width="140">
            </el-table-column>
            <el-table-column
                prop="creator"
                :label="$t('kbType.creator', { msg: 'kbType.creator' })"
                width="100">
            </el-table-column>
            <el-table-column
                prop="createTime"
                :label="$t('kbReview.table.createTime', { msg: 'kbReview.table.createTime' })">
            </el-table-column>
            <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="230">
            <template #default="scope">
                <el-button
                    size="mini"
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)">{{ $t('kbReview.approve', { msg: 'kbReview.approve' }) }}</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
            
            </template>
            </el-table-column>
            </el-table>
                <div class="pagination-tools">
            <!--
                background:带背景的页码
                layout：分页条布局
                    prev：上页按钮
                    pager：页码
                    next：下一页按钮
                    sizes:每页显示数量
                    jump：跳转到第几页
                    ->：定位其内容居右显示
                    total：总条目数
                :page-size.sync="pageParam.pageSize":每页条目数   问题1
                :current-page.sync="pageParam.pageNum"：当前页码  问题2
                :page-sizes="pageSizes"：条目列表
                :total="total"：总条目数
                :hide-on-single-page="true":当只有一页时隐藏分页条
            -->
            <el-pagination
                background
                layout="sizes,prev, pager, next,jumper,->,total"
                :page-size="this.pageParam.pageSize"
                :current-page="this.pageParam.pageNum"
                :page-sizes="pageSizes"
                :total="total"
                :hide-on-single-page="true"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
            >
            </el-pagination>
            </div>
            <!-- 修改页面 -->
            <el-dialog :title="$t('kbReview.kbR', { msg: 'kbReview.kbR' })" 
                v-model="dialogFormVisible"
                width="90%"
                :before-close="typeDialogClose">
                <el-form ref="form" :model="form" label-width="105px" :rules="rules">
                           <!-- <el-form-item label="编号:">
                                <el-input v-model="form.id"></el-input>
                            </el-form-item> -->
                            <el-form-item :label="$t('kbReview.theme', { msg: 'kbReview.theme' })" prop="title">
                                <el-input v-model="form.title" :placeholder="$t('kbinfo.themeD', { msg: 'kbinfo.themeD' })"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('kbReview.table.kbType', { msg: 'kbReview.table.kbType' })" prop="typeId">
                              <div style="text-align: left;">
                                <el-cascader 
                                style="width: 24%"
                                :placeholder="$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' })"
                                ref="refCascader"
                                @change="handleCascader"
                                :options="typeTree" 
                                v-model="form.typeId" 
                                :props="{
                                  value: 'id',
                                  label: 'type'
                                }"
                                ></el-cascader>
                          </div>
                            </el-form-item>
                            <el-form-item :label="$t('kbType.tag', { msg: 'kbType.tag' })" >
                              <div style="text-align: left;">
                                
                              <el-select v-model="tagsId" multiple clearable :placeholder="$t('kbReview.table.selecttag', { msg: 'kbReview.table.selecttag' })" style="width: 24%">
                                <el-option
                                  v-for="item in form.tags"
                                  :key="item.id"
                                  :label="item.tag"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                            </div>
                            </el-form-item>
                            <el-form-item :label="$t('kbReview.table.solution', { msg: 'kbReview.table.solution' })" prop="solution">
                                <!-- <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 25}" v-model="form.solution"></el-input> -->
                                <div style="border: 1px solid #ccc; z-index: 1001;">
                                  <Toolbar
                                      style="border-bottom: 1px solid #ccc"
                                      :editor="editor"
                                      :defaultConfig="toolbarConfig"
                                      :mode="mode"
                                  />
                                  <Editor
                                      style="height: 300px; overflow-y: hidden;"
                                      v-model="form.solution"
                                      :defaultConfig="editorConfig"
                                      :mode="mode"
                                      @onCreated="onCreated"
                                  />
                              </div>
                            </el-form-item>
                            <el-form-item :label="$t('kbReview.approve', { msg: 'kbReview.approve' })" prop="isPass">
                                <el-radio-group v-model="form.isPass" @change="editKb('form')">
                                <!-- <el-radio-button label="0">{{ $t('kbReview.toBeReview', { msg: 'kbReview.toBeReview' }) }}</el-radio-button> -->
                                <el-radio-button label="1">{{ $t('kbReview.pass', { msg: 'kbReview.pass' }) }}</el-radio-button>
                                <el-radio-button label="2">{{ $t('kbReview.reviewNoPass', { msg: 'kbReview.reviewNoPass' }) }}</el-radio-button>
                                <el-radio-button @click="dialogFormVisible = false">{{ $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-radio-button>
                                </el-radio-group>
                                <!-- <el-button type="warning" @click="dialogFormVisible = false" plain>{{  $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-button> -->
                            </el-form-item>
                            <!-- <el-form-item>
                                <el-button type="primary" @click="editKb('form')">{{ $t('kbReview.review', { msg: 'kbReview.review' }) }}</el-button>
                                <el-button @click="dialogFormVisible = false">{{  $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-button>
                            </el-form-item> -->
                        </el-form>
            </el-dialog>

      </el-tab-pane>
      <el-tab-pane :label="$t('kbReview.kbRecycle', { msg: 'kbReview.kbRecycle' })" name="third">
        
        <div>
            <el-steps :active="3" finish-status="success" simple style="margin-top: 20px">
            <el-step :title="$t('kbReview.review', { msg: 'kbReview.review' })" ></el-step>
            <!-- <el-step :title="$t('kbReview.pass', { msg: 'kbReview.pass' })" ></el-step> -->
            <el-step :title="$t('kbReview.recycle', { msg: 'kbReview.recyle' })" icon="el-icon-delete"></el-step>
            </el-steps>
        </div>
        <el-table
            highlight-current-row
            border
            :data="draftTableList"
            style="width: 100%"
            :row-class-name="tableRowClassName">
            <el-table-column
                prop="id"
                :label="$t('kbReview.table.id', { msg: 'kbReview.table.id' })"
                width="80">
            </el-table-column>
            <el-table-column
                prop="title"
                :label="$t('kbReview.table.title', { msg: 'kbReview.table.title' })"
                width="298">
            </el-table-column>
            <el-table-column
                prop="type"
                :label="$t('kbReview.table.kbType', { msg: 'kbReview.table.kbType' })"
                width="120">
            </el-table-column>
            <el-table-column
                prop="solution"
                :label="$t('kbReview.table.solution', { msg: 'kbReview.table.solution' })"
                width="660">
            </el-table-column>
            <el-table-column
                prop="updateTime"
                width="180"
                :label="$t('kbinfo.table.time', { msg: 'kbinfo.table.time' })"
                >
            </el-table-column>
            <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="260">
            <template #default="scope">
              <el-button
                    size="mini"
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleReview(scope.$index, scope.row.id)">{{ $t('kbReview.backToApprove', { msg: 'kbReview.backToApprove' }) }}</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
            </template>
            </el-table-column>
            </el-table>
                <div class="pagination-tools">
            <!--
                background:带背景的页码
                layout：分页条布局
                    prev：上页按钮
                    pager：页码
                    next：下一页按钮
                    sizes:每页显示数量
                    jump：跳转到第几页
                    ->：定位其内容居右显示
                    total：总条目数
                :page-size.sync="pageParam.pageSize":每页条目数   问题1
                :current-page.sync="pageParam.pageNum"：当前页码  问题2
                :page-sizes="pageSizes"：条目列表
                :total="total"：总条目数
                :hide-on-single-page="true":当只有一页时隐藏分页条
            -->
            <el-pagination
                background
                layout="sizes,prev, pager, next,jumper,->,total"
                :page-size="this.pageDraft.pageLenth"
                :current-page="this.pageDraft.pageStart"
                :page-sizes="pageSizes"
                :total="totalDraft"
                :hide-on-single-page="true"
                @current-change="handleCurrentChangeDraft"
                @size-change="handleSizeChangeDraft"
            >
            </el-pagination>
                </div>

    </el-tab-pane>
    </el-tabs>
  </template>

  <script>
  import { baseUrl_New } from '../../axios/urlconfig';
  import axios from 'axios';
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
  import { DomEditor } from '@wangeditor/editor';
import { deleteRequest, getRequest, postRequest } from '../../axios/axios';


    export default {
      components: { Editor, Toolbar },
      data() {
        return {
          toolbar: null,
          editor: null,
          html: '',
          toolbarConfig: {
            // showLinkImg: false,
          //uploadImgShowBase64: false,
	        excludeKeys: [  //删除工具栏的插件
	          'insertVideo', // 删除视频
	          'uploadVideo',
	          'group-video',
	          //'insertImage',// 删除网络图片上传
	          'insertLink',// 删除链接
	          'codeBlock',// 删除代码块
            "emotion", //表情
            //"uploadImage",//删除图片
            //"insertTable", // 插入表格删除
	        ]
           },
          editorConfig: { 
            placeholder: this.$t('issue.issueD', { msg: 'issue.issueD' }),
             readOnly: false, // 是否只允许阅读，不可编辑
		         //autoFocus: true,
             MENU_CONF: {
		          // 配置上传图片,只允许base64上传
		          uploadImage: {
		            server: baseUrl_New+'/oss/file/uploadEditor', // 上传接口
                fieldName: 'file',
		            allowedFileTypes: ['image/*'],
		            maxFileSize: 1 * 1024 * 1024, // 1M
		           // base64LimitSize: 1 * 1024 * 1024, // 1g 以下插入 base64
               // 将 meta 拼接到 url 参数中，默认 false
               // metaWithUrl: false,
              onSuccess(file, res) {          // JS 语法
                  console.log(`${file.name} 上传成功`, res)
              },

                // 自定义上传
             // customInsert(res, insertFn) {
              //insertFn(res[0].url); //同步插入,顺序不会乱
            //  },
                            
		            onError: (file, err, res) => {
		             this.$message.warning('当前选择的图片过大！请选择1M以内')
		            },
		          },
		     }  

         },
          mode: 'default', // or 'simple'
          showDrawer: false,
          knowledgeBase: null, //单个知识库
          activeName: 'first',
          tableData: [],
          passTableList:[],  //审核通过列表
          draftTableList:[],
          pageParam: {//分页参数
          pageNum: 1,//当前页
          pageSize: 10,//每页条目数据
        },
        total: 0,//总条目数
        totalPass:0,
        totalDraft:0,
        pageSizes: [10, 20, 30, 40],//每页显示条目数列表
        dialogFormVisible:false,
        form: {   //新增知识库
          id:'',
          title: '',
          typeId:'',
          tags:[],
          type:'',
          isPass:'',
          solution: '',
        },
        formOther: {   
          id:'',
          title: '',
          typeId:'',
          type:'',
          isPass:'',
          solution: '',
        },
        typeList:[],
        pagePass: {//分页参数
          pageStart: 1,//当前页
          pageLenth: 10,//每页条目数据
        },
        pageDraft: {//分页参数
          pageStart: 1,//当前页
          pageLenth: 10,//每页条目数据
        },
        typeTree:[],//知识类别两层结构
        tags:[
        {
          id: '',
          tag: '',
            }
        ],
        tagsId:[],
        rules:{
          title: [
            { required: true, message: this.$t('kbinfo.themeD', { msg: 'kbinfo.themeD' }), trigger: 'blur' }
          ],
          typeId: [
            { required: true, message: this.$t('kbReview.kbTypeD', { msg: 'kbReview.kbTypeD' }), trigger: 'change' }
          ],
          solution: [
            { required: true, message: this.$t('kbReview.solutionD', { msg: 'kbReview.solutionD' }), trigger: 'blur' }
          ],
          isPass:[
          { required: true, message: this.$t('kbReview.reviewD', { msg: 'kbReview.reviewD' }), trigger: 'change' }
          ],
        },

        };
      },

      created(){
        this.getAllList();
        //this.getTypeAll();
        this.getPassList();
        this.getDraftList();
        this.getTypeTree();
       
      },
      beforeUnmount() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
      },

      methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            // toolbar = DomEditor.getToolbar(editor);
            // console.log(toolbar.getConfig().toolbarKeys)
        },
        handleClick(tab, event) {
          //console.log(tab, event);
        },
        //table样式
        tableRowClassName({row, rowIndex}) {
          if (rowIndex%4 === 1) {
            return 'warning-row';
          } else if (rowIndex%4 === 3) {
            return 'success-row';
          }
          return '';
        },

        //表格数据列表
        //获取所有的知识类别
       getAllList(){
        getRequest(baseUrl_New+'/kb/notPass/'+ this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response=>{
          //获得服务器端回传的map对象
          let resultMap = response;
            //从集合中获取用户列表及总条目数
            this.tableData = resultMap.list;
            this.total = resultMap.total;
        })
       },
        handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageParam.pageSize = val;
        this.getAllList();
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageParam.pageNum = val;
        this.getAllList();
        },
        handleDelete(index, id){
        this.$confirm( this.$t('kbReview.deleteD', { msg: 'kbReview.deleteD' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
            cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            deleteRequest(baseUrl_New + `/kb/del/${id}`)
            .then(response=>{
            // console.log(response);
                if (response.code == 0){
                this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
                    this.getAllList();
                    this.getPassList();
                    this.getDraftList();
                }else{
                this.message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
                }
            })
        })
        },
        typeDialogClose(){  //关闭新增对话框
       this. dialogFormVisible = false;
       },
       handleEdit(index, row){
        this.html = this.form.solution;
        this.dialogFormVisible=true;
        this.form = JSON.parse(JSON.stringify(row));
        this.getTagByKBId();
       },
       getTypeAll(){
          getRequest(baseUrl_New+'/kType/list').then(response=>{
            let resultMap = response;
            this.typeList=resultMap.list;
          })
        },
        editKb(formName){
          this.$refs[formName].validate((valid) => {
          if (valid) {
            var that = this
        postRequest(baseUrl_New + '/kb/updateKB',{
          id:this.form.id,
          title:this.form.title,
          typeId:this.form.typeId,
          tagsId:this.tagsId,
          solution:this.form.solution,
          isPass:this.form.isPass
        }).then(resp=>{
          this.typeDialogClose();
          this.getAllList();
          this.getDraftList();
          this.getPassList();
          //清空form输入框
          this.form={};
          this.$message.success(this.$t('kbReview.reviewS', { msg: 'kbReview.reviewS' }));
        }).catch(err => {
          this.$message.error(this.$t('issue.error', { msg: 'issue.error' }))
        })
          } else {
            
            return false;
          }
        });
            
        },
        getPassList(){
        getRequest(baseUrl_New+'/kb/page/'+ this.pagePass.pageStart + '/' + this.pagePass.pageLenth).then(response=>{
          //获得服务器端回传的map对象
          let resultMap = response;
            //从集合中获取用户列表及总条目数
            this.passTableList = resultMap.list;
            this.totalPass = resultMap.total;
        })
       },
       handleSizeChangePass(val) {
        // console.log(`每页 ${val} 条`);
        this.pagePass.pageLenth = val;
        this.getPassList();
        },
        handleCurrentChangePass(val) {
        // console.log(`当前页: ${val}`);
        this.pagePass.pageStart = val;
        this.getPassList();
        },
        getDraftList(){
        getRequest(baseUrl_New+'/kb/draft/'+ this.pageDraft.pageStart + '/' + this.pageDraft.pageLenth).then(response=>{
          //获得服务器端回传的map对象
          let resultMap = response;
            //从集合中获取用户列表及总条目数
            this.draftTableList = resultMap.list;
            this.totalDraft = resultMap.total;
        })
       },
       handleSizeChangeDraft(val) {
        // console.log(`每页 ${val} 条`);
        this.pageDraft.pageLenth = val;
        this.getDraftList();
        },
        handleCurrentChangeDraft(val) {
        // console.log(`当前页: ${val}`);
        this.pageDraft.pageStart = val;
        this.getDraftList();
        },
        handleReview(index,id){
          this.$confirm(this.$t('kbReview.toBeApproved', { msg: 'kbReview.toBeApproved' }),  this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText:  this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
            cancelButtonText:  this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            postRequest(baseUrl_New + `/kb/revertById/${id}`)
            .then(response=>{
              console.log(response);
                if (response.code == 0){
                this.$message.success(this.$t('kbReview.approveS', { msg: 'kbReview.approveS' }))
                    this.getDraftList();
                    this.getAllList();
                    this.getPassList();
                }else{
                this.message.error(this.$t('kbReview.approveF', { msg: 'kbReview.approveF' }));
                }
            })
        })
        },
        handleOpen(val){
          this.showDrawer = true;
          this.knowledgeBase = val;
        },
        handleOpenEdit(row){
        this.html = this.form.solution;
        this.dialogFormVisible=true;
        this.form = JSON.parse(JSON.stringify(row));
        this.getTagByKBId();
        
        },
        handleCascader(){
        this.form.typeId = this.$refs["refCascader"].getCheckedNodes()[0].value; //获取最后一个id
        this.form.tags = [];
        getRequest(baseUrl_New+'/kType/tag?id='+this.form.typeId).then(response=>{
            let resultMap = response.data;
            this.tags=resultMap.list;
            this.form.tags=this.tags;
          })
      },
      getTagByKBId(){
        this.tagsId=[];
        this.form.tags.forEach(tag => {
        this.tagsId.push(tag.id);
      });
      },
      getTypeTree(){
        getRequest(baseUrl_New+'/kType/getType').then(response=>{
            let resultMap = response;
            this.typeTree=resultMap.data.typeTree;
          })
      },



      }
    };
  </script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style scoped>
.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
</style>